import * as React from "react";
const SvgFiRrHouseUser = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-house-user_svg__a)">
      <path
        fill="#062147"
        d="m21.797 5.539-7-4.724a4.98 4.98 0 0 0-5.594 0l-7 4.724A5 5 0 0 0 0 9.685V19c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V9.685a5 5 0 0 0-2.203-4.146M8 21.999c0-2.205 1.794-4 4-4s4 1.795 4 4zm14-3c0 1.655-1.346 3-3 3h-1c0-3.308-2.691-6-6-6s-6 2.692-6 6H5c-1.654 0-3-1.345-3-3V9.686c0-1 .494-1.93 1.322-2.487l7-4.724A3 3 0 0 1 12 1.958c.584 0 1.168.172 1.678.516l7 4.724A3 3 0 0 1 22 9.685zM12 7c-2.206 0-4 1.795-4 4 0 2.207 1.794 4 4 4s4-1.793 4-4c0-2.205-1.794-4-4-4m0 6c-1.103 0-2-.896-2-2 0-1.102.897-2 2-2s2 .898 2 2c0 1.104-.897 2-2 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-house-user_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHouseUser;
